{
  "open": "Abrir chat",
  "unread_one": "{count} mensagem não lida",
  "unread_many": "{count} de mensagens não lidas",
  "unread_other": "{count} mensagens não lidas",
  "close": "Fechar"
}
